import React from 'react';
import styled, { css } from 'styled-components';
import { SwiperSlide } from 'swiper/react';

import { useMedia } from '@tager/web-core';

import {
  ContentContainer,
  Title,
} from '@/modules/ElectrocarsLanding/common.styles';
import PostCard from '@/components/PostCard';
import { media } from '@/utils/mixin';
import { useElectrocarsLandingData } from '@/modules/ElectrocarsLanding/hooks';
import { colors } from '@/constants/theme';
import { SliderWrapper } from '@/components/LandingWidgets';
import { Header as SliderWrapperHeader } from '@/components/LandingWidgets/components/SliderWrapper';
import { ButtonNextLink } from '@/components/Button';

function News() {
  const { newsTitle, newsButtonTitle, newsButtonLink, newsItems } =
    useElectrocarsLandingData();
  const isMobile = useMedia('(max-width: 767px)');

  if (!newsItems || newsItems.length === 0) {
    return null;
  }

  const slidesPerView = !isMobile ? 3 : undefined;
  const isWithoutNavs = !isMobile ? newsItems.length <= 3 : true;
  const isNoSwiping = !isMobile
    ? newsItems.length <= 3
    : newsItems.length === 1;

  return (
    <Component id="news">
      <ContentContainer>
        <Title isBlack>{newsTitle}</Title>

        <Slider>
          <SliderWrapper
            id={5}
            options={{
              slidesPerView,
              spaceBetween: 20,
              noSwipingClass: 'swiper-no-swiping',
              withoutNavs: isWithoutNavs,
              withoutPagination: true,
            }}
          >
            {newsItems.map(({ image, title, link }, index) => (
              <SwiperSlide
                key={index}
                className={isNoSwiping ? 'swiper-no-swiping' : ''}
              >
                <PostCard title={title ?? ''} url={link ?? ''} image={image} />
              </SwiperSlide>
            ))}
          </SliderWrapper>
        </Slider>

        <Action>
          <StyledButtonLink variant="outlined" to={newsButtonLink}>
            {newsButtonTitle}
          </StyledButtonLink>
        </Action>
      </ContentContainer>
    </Component>
  );
}

export default News;

const Component = styled.section`
  position: relative;
  padding: 30px 0 60px;

  ${media.tablet(css`
    padding: 20px 0 40px;
  `)}
`;

const Slider = styled.div`
  margin-top: 58px;

  ${media.tablet(css`
    margin-top: 30px;
  `)}

  ${media.mobile(css`
    margin: 30px -20px 0 0;

    .swiper-slide {
      min-width: calc(100% - 40px);
      flex-shrink: initial;
    }
  `)}

  ${SliderWrapperHeader} {
    top: -100px;

    ${media.tablet(css`
      top: -60px;
    `)}

    ${media.mobile(css`
      right: 20px;
    `)}

    .swiper-prev6:not(.swiper-button-disabled),
    .swiper-next6:not(.swiper-button-disabled) {
      border: 1px solid ${colors.main};
    }
  }
`;

const Action = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 58px;

  ${media.tablet(css`
    margin-top: 40px;
  `)}
`;

const StyledButtonLink = styled(ButtonNextLink)`
  max-width: 226px;

  ${media.tablet(css`
    max-width: 280px;
  `)}
`;
